"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiteralVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class LiteralVariable {
  constructor() {
    (0, _defineProperty2.default)(this, "settings", LiteralVariable.settings);
    (0, _defineProperty2.default)(this, "type", "literal");
    (0, _defineProperty2.default)(this, "valueType", "value");
    (0, _defineProperty2.default)(this, "label", "Literal Value");
    (0, _defineProperty2.default)(this, "description", "Enter a value that doesn't change.");
  }
  getValue(ref, deps) {
    ref.value = deps;
  }
  dependencies(params, resolver) {
    return params.value;
  }
}
exports.LiteralVariable = LiteralVariable;
(0, _defineProperty2.default)(LiteralVariable, "settings", {
  value: {
    type: "literal",
    description: "The literal value to use."
  }
});
//# sourceMappingURL=LiteralVariable.js.map